module.exports = __webpack_public_path__ + "static/media/user.07770999.svg";